import { setCookie } from 'cookies-next';

export const setRememberMeCookie = (ssn: string, isPersistent: boolean = true): void => {
  const expires = new Date();
  expires.setDate(expires.getDate() + 30);

  setCookie('remember_me', ssn, { expires: isPersistent ? expires : undefined });
};
